/**
 * A shimmering placeholder bar/block, sized via `className` (e.g.
 * `h-4 w-32`). Used in place of a spinner wherever the final content's
 * approximate shape/position is already known (a title, a badge, a table
 * row) - it reads as "this specific thing is loading" rather than "the
 * whole page is doing something", and its size holds the layout steady so
 * nothing jumps when the real content swaps in.
 */
export default function Skeleton({ className = '' }: { className?: string }) {
  return (
    <span className={`relative inline-block overflow-hidden rounded bg-bg-tertiary ${className}`} role="status" aria-label="Loading">
      <span className="absolute inset-0 -translate-x-full animate-shimmer bg-gradient-to-r from-transparent via-white/40 to-transparent" />
    </span>
  )
}
